import { DOCUMENT } from '@angular/common';
import { Component, DestroyRef, ElementRef, Inject, OnInit, Renderer2, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatMenuTrigger } from '@angular/material/menu';
import { AdminAuthProfile, AdminAuthSession, AuthService } from '../../core/service/auth.service';
import { ConfigService } from '../../core/service/config.service';
import { UtilService } from '../../core/service/util.service';
import { BaseService } from 'src/app/graphql-queries/base.service';
const document: any = window.document;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  user: AdminAuthProfile | null = null;
  displayName = '';
  avatarInitial = '';
  userEmail = '';
  roleLabel = '';
  org: any;
  profileUrl:  string = "";
  public config: any = {};
  userImg: string = "";
  homePage: string = "";
  isNavbarCollapsed = true;
  tabWidth: string = "";
  currentTab: number = 0;
  currentHoverTab: number = -1;
  rightClickMenuIndex = -1;
  rightClickMenuPosition = { x: 0, y: 0 };
  employee_details: any;
  is_employee_info_loading: boolean = false;
  @ViewChild(MatMenuTrigger) rightClickMenu!: MatMenuTrigger;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public renderer: Renderer2,
    public elementRef: ElementRef,
    private _auth: AuthService,
    private _base: BaseService,
    private _config: ConfigService,
    public _util: UtilService,
    private _container: ViewContainerRef
  ) {}

  notifications: any[] = [
    {
      userImg: "assets/images/user/user1.jpg",
      userName: "Sarah Smith",
      time: "14 mins ago",
      message: "Please check your mail",
    },
    {
      userImg: "assets/images/user/user2.jpg",
      userName: "Airi Satou",
      time: "22 mins ago",
      message: "Work Completed !!!",
    },
    {
      userImg: "assets/images/user/user3.jpg",
      userName: "John Doe",
      time: "3 hours ago",
      message: "kindly help me for code.",
    },
    {
      userImg: "assets/images/user/user4.jpg",
      userName: "Ashton Cox",
      time: "5 hours ago",
      message: "Lets break for lunch...",
    },
    {
      userImg: "assets/images/user/user5.jpg",
      userName: "Sarah Smith",
      time: "14 mins ago",
      message: "Please check your mail",
    },
    {
      userImg: "assets/images/user/user6.jpg",
      userName: "Airi Satou",
      time: "22 mins ago",
      message: "Work Completed !!!",
    },
    {
      userImg: "assets/images/user/user7.jpg",
      userName: "John Doe",
      time: "3 hours ago",
      message: "kindly help me for code.",
    },
  ];

  ngOnInit() {
    this.config = {};
    this.syncUserFromSession(this._auth.currentUserValue);
    this._auth.currentUser.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((session) => {
      this.syncUserFromSession(session);
    });
  }

  private syncUserFromSession(session: AdminAuthSession | null) {
    this.user = session?.profile ?? null;
    this.displayName = this._auth.getDisplayName(session);
    this.avatarInitial = this._auth.getAvatarInitial(session);
    this.userEmail = this._auth.getProfileEmail(session);
    this.roleLabel = this._auth.getRoleLabel(session);
  }

  ngAfterViewInit() {
    // set theme on startup
    this.renderer.addClass(this.document.body, this.config?.layout?.variant);
    this.renderer.addClass(this.document.body, "menu_" + this.config?.layout?.sidebar?.backgroundColor);
    this.renderer.addClass(this.document.body, "logo-" + this.config?.layout?.logo_bg_color);
    this.renderer.addClass(this.document.body, "theme-" + this.config?.layout?.theme_color);
  }

  callFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }

  logout() {
    this._auth.logout();
  }

  trackByItem(index: number, item: { id?: string; moduleName?: string; name?: string; path?: string; userName?: string; time?: string }): string | number {
    return item?.id ?? item?.moduleName ?? item?.name ?? item?.path ?? item?.userName ?? index;
  }

  trackByIndex(index: number): number {
    return index;
  }
}
